import type { RouteLocationNormalized } from 'vue-router';

function removeExtraFbclid(param: string): { param: string, fbclid?: string } {
  if (param && param.includes('fbclid')) {
    const matchIndex = param.indexOf('fbclid=');

    if (matchIndex !== -1) {
      const fbclid = param.slice(matchIndex).split('=')[1];
      return { param: param.substring(0, matchIndex - 1), fbclid };
    }
  }

  return { param };
}
export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
  // удаляет второй fbclid который fb криво добавляет при переходе в другой браузер
  const router = useRouter();

  if (to.query) {
    const cleanedQuery: { [key: string]: string } = {};
    let hasSomeChanges = false;

    for (const key in to.query) {
      const { param, fbclid } = removeExtraFbclid(to.query[key] as string);
      if (param !== to.query[key]) {
        hasSomeChanges = true;
        cleanedQuery[key] = param;

        if (fbclid) {
          cleanedQuery.fbclid = fbclid;
        }
      } else {
        cleanedQuery[key] = to.query[key];
      }
    }

    if (hasSomeChanges) {
      const resolved = router.resolve({ path: to.path, query: cleanedQuery });

      return navigateTo(resolved);
    }
  }
});
